import Swal from 'sweetalert2';
import cabine from '../../../services/cabineApi';
import { getPartnerProfileAction } from '../../duck/productsPage/partnerData';
import { getProductsListAction } from '../../duck/productsPage/products';
import { getProfileProductsAuthAction } from '../../duck/productsPage/profileAuth';
import { getUserAction } from '../../duck/productsPage/profileData';
import { Logout, SendLoginTokenAuth } from '../tokens';

export function getProducts() {
  return (dispatch: any) => {
    cabine
      .get('/v1/sistemas', SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(getProductsListAction(response.data.retorno));
      })
      .catch((error: any) => {
        if (
          error.response !== undefined &&
          error.response.data === 'Unauthorized.'
        ) {
          Swal.fire({
            icon: 'warning',
            title: 'Sua sessão encerrou!',
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(Logout());
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: 'Ocorreu um erro durante a requisição, tente novamente mais tarde!',
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(Logout());
            }
          });
        }
      });
  };
}

export function getProfileUser() {
  return (dispatch: any) => {
    cabine
      .get('/v1/perfil', SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(getUserAction(response.data.retorno));
      })
      .catch((error: any) => {
        if (
          error.response !== undefined &&
          error.response.data === 'Unauthorized.'
        ) {
          Swal.fire({
            icon: 'warning',
            title: 'Sua sessão encerrou!',
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(Logout());
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: 'Ocorreu um erro durante a requisição, tente novamente mais tarde!',
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(Logout());
            }
          });
        }
      });
  };
}

export function getProfileAuth(id: string | number | undefined) {
  return (dispatch: any) => {
    cabine
      .get(`/v1/acesso/usuario/${id}`, SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(getProfileProductsAuthAction(response.data.retorno));
      })
      .catch((error: any) => {
        if (
          error.response !== undefined &&
          error.response.data === 'Unauthorized.'
        ) {
          Swal.fire({
            icon: 'warning',
            title: 'Sua sessão encerrou!',
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(Logout());
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: 'Ocorreu um erro durante a requisição, tente novamente mais tarde!',
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(Logout());
            }
          });
        }
      });
  };
}

export function getPartnerProfile(id: string | number | undefined) {
  return (dispatch: any) => {
    cabine
      .get(`/v1/parceiros/${id}`, SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(getPartnerProfileAction(response.data.retorno));
      })
      .catch(() => {
        // if (
        //   error.response !== undefined &&
        //   error.response.data === 'Unauthorized.'
        // ) {
        //   Swal.fire({
        //     icon: 'warning',
        //     title: 'Sua sessão encerrou!',
        //   }).then((result) => {
        //     if (result.isConfirmed) {
        //       dispatch(Logout());
        //     }
        //   });
        // } else {
        //   Swal.fire({
        //     icon: 'error',
        //     title: 'Erro!',
        //     text: 'Ocorreu um erro durante a requisição, tente novamente mais tarde!',
        //   }).then((result) => {
        //     if (result.isConfirmed) {
        //       dispatch(Logout());
        //     }
        //   });
      });
  };
}
